import { render, staticRenderFns } from "./PagesBlogArticleCategory.vue?vue&type=template&id=3a6e9d72&scoped=true&"
import script from "./PagesBlogArticleCategory.vue?vue&type=script&lang=js&"
export * from "./PagesBlogArticleCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6e9d72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VInput } from 'vuetify/lib/components/VInput';
installComponents(component, {VBtn,VCard,VForm,VInput})
